__turbopack_context__.v({
  "icon": "style-module-scss-module__hxRKKa__icon",
  "left": "style-module-scss-module__hxRKKa__left",
  "price": "style-module-scss-module__hxRKKa__price",
  "root": "style-module-scss-module__hxRKKa__root",
});
